import * as types from "../../../_constants/types";

export default (state = { loading: false }, action) => {
    switch (action.type) {
        case types.LANGUAGE_LIST_FETCHING:
            return { loading: true };

        case types.LANGUAGE_LIST_FETCHING_COMPLETED:
            return { loading: false };

        case types.LANGUAGE_LIST_FETCHING_FAILED:
            return { loading: false, err: action.type };

        default:
            return state;
    }
};
